import type { IPaginated } from './IPagination';

export class Paginated<T> implements IPaginated<T> {
  public constructor(
    public readonly items: T[] = [],
    public readonly totalItems: number = 0,
    public readonly itemsPerPage: number = 0,
    public readonly currentPage: number = 0,
    public readonly lastPage: number = 0
  ) {}

  public append(newPaginated: Paginated<T>): Paginated<T> {
    return new Paginated<T>(
      this.items.concat(newPaginated.items),
      newPaginated.totalItems,
      newPaginated.itemsPerPage,
      newPaginated.currentPage,
      newPaginated.lastPage
    );
  }

  public add(item: T): Paginated<T> {
    return new Paginated<T>(
      this.items.concat(item),
      this.totalItems,
      this.itemsPerPage,
      this.currentPage,
      this.lastPage
    );
  }

  public isMore(): boolean {
    return this.currentPage < this.lastPage;
  }
}
